export default {"src":"/_next/static/media/SR.3b23680f.svg","height":18,"width":18};